<template>
  <form @submit.prevent="submit">
    <b-card>
      <fields />
    </b-card>

    <b-button type="submit" variant="primary">
      {{ $t('general.save') }}
    </b-button>
    <b-button type="button" variant="light" class="ml-2" @click="cancel">
      {{ $t('general.cancel') }}
    </b-button>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'

export default {
  mixins: [ResourceFormMixin],

  props: {
    airportId: { type: [Number, String], required: true },
    editId: { type: [Number, String], required: false, default: null },
    apiInterface: { type: Object, required: true },
  },

  data() {
    return {
      base: 'airport-companies',
      loaded: false,
    }
  },

  computed: {
    form() {
      return this
    },
  },
  watch: {
    id() {
      this.load()
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    api() {
      return this.apiInterface
    },

    submit() {
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    load() {
      this.loaded = false
      this.loadForm().then(() => {
        this.loaded = true
      })
    },
  },
}
</script>
